export const ADMIN_MENU = {
    DASHBOARD : {
        TYPE : 'MAIN',
        ID: 'DASHBOARD',
        URL : '/admin',
        TEXT : '대시보드'
    },
    ITEM : {
        TYPE : 'MAIN',
        ID: 'ITEM',
        URL : '/admin/items',
        TEXT : '자산관리'
    },
    ITEM_LIST : {
        P_MENU: 'ITEM',
        TYPE : 'SUB',
        ID: 'ITEM_LIST',
        URL : '/admin/items',
        TEXT : '자산목록'
    },
    INSPECT : {
        P_MENU: 'ITEM',
        TYPE : 'SUB',
        ID: 'INSPECT',
        URL : '/admin/inspects',
        TEXT : '자산조사'
    },
    ITEM_HIST : {
        P_MENU: 'ITEM',
        TYPE : 'SUB',
        ID: 'ITEM_HIST',
        URL : '/admin/items/hist',
        TEXT : '자산이력'
    },
    ITEM_REL : {
        P_MENU: 'ITEM',
        TYPE : 'SUB',
        ID: 'ITEM_REL',
        URL : '/admin/items/rel',
        TEXT : '자산연계'
    },
    SUPPLIES : {
        TYPE : 'MAIN',
        ID: 'SUPPLIES',
        URL : '/admin/supplies',
        TEXT : '소모품 관리'
    },
    SUPPLIES_LIST : {
        P_MENU: 'SUPPLIES',
        TYPE : 'SUB',
        ID: 'SUPPLIES_LIST',
        URL : '/admin/supplies',
        TEXT : '소모품목록'
    },
    INOUT : {
        TYPE : 'MAIN',
        ID: 'INOUT',
        URL : '/admin/inout',
        TEXT : '반출입 관리'
    },
    INOUT_LIST : {
        P_MENU: 'INOUT',
        TYPE : 'SUB',
        ID: 'INOUT_LIST',
        URL : '/admin/inout',
        TEXT : '반출입내역'
    },
    INOUT_HIST : {
        P_MENU: 'INOUT',
        TYPE : 'SUB',
        ID: 'INOUT_HIST',
        URL : '/admin/inoutHist',
        TEXT : '반출입이력'
    },
    STATIC_SEARCH : {
        P_MENU: 'INOUT',
        TYPE : 'SUB',
        ID: 'STATIC_SEARCH',
        URL : '/admin/static/searchItem',
        TEXT : '조사장비'
    },
    INOUT_MOD : {
        P_MENU: 'INOUT',
        TYPE : 'SUB',
        ID: 'INOUT_MOD',
        URL : '/admin/inoutHist',
        TEXT : '조사변경'
    },
    STATIC : {
        TYPE : 'MAIN',
        ID: 'STATIC',
        URL : '/admin/static/item',
        TEXT : '통계'
    },
    STATIC_ITEM : {
        P_MENU: 'STATIC',
        TYPE : 'SUB',
        ID: 'STATIC_ITEM',
        URL : '/admin/static/item',
        TEXT : '자산현황'
    },
    STATIC_INOUT : {
        P_MENU: 'STATIC',
        TYPE : 'SUB',
        ID: 'STATIC_INOUT',
        URL : '/admin/static/inout',
        TEXT : '조사설치 현황'
    },
    STATIC_INSPECT : {
        P_MENU: 'STATIC',
        TYPE : 'SUB',
        ID: 'STATIC_INSPECT',
        URL : '/admin/static/inspect',
        TEXT : '자산조사 현황'
    },
    SETTING : {
        TYPE : 'MAIN',
        ID: 'SETTING',
        URL : '/admin/setting/client',
        TEXT : '설정'
    },
    PASSWORD : {
        P_MENU: 'SETTING',
        TYPE : 'SUB',
        URL : '/admin/setting/password',
        TEXT : '비밀번호 변경'
    }, 
    USERS : {
        P_MENU: 'SETTING',
        TYPE : 'SUB',
        URL : '/admin/setting/users',
        TEXT : '사용자 관리'
    }, 
    CLIENT : {
        P_MENU: 'SETTING',
        TYPE : 'SUB',
        URL : '/admin/setting/client',
        TEXT : '거래처 관리'
    }, 
    PARAM_MENU_INSPECT : {
        P_MENU: 'INSPECT',
        TYPE : 'SUB',
        ID: 'PARAM_MENU_INSPECT',
        URL : '/admin/static/inout',
        TEXT : '자산조사 상세'
    },
    PARAM_MENU_INOUT : {
        P_MENU: 'INOUT_LIST',
        TYPE : 'SUB',
        ID: 'PARAM_MENU_INOUT',
        URL : '/admin/static/inout',
        TEXT : '반출입 상세'
    }
}

const MOBILE_MENU = {
    INOUT : {
        TYPE : 'MAIN',
        ID: 'INOUT',
        TEXT : '자산 반출입'
    },
    INOUT_SEARCH : {
        P_MENU: 'INOUT',
        TYPE : 'SUB',
        URL : '/inout/S',
        TEXT : '조사설치',
        ICON : '/images/ic_inout_reasearch.svg'
    }, 
    INOUT_MOD : {
        P_MENU: 'INOUT',
        TYPE : 'SUB',
        URL : '/itemInout',
        TEXT : '조사변경',
        ICON : '/images/ic_inout_swap.svg'
    }, 
    INOUT_FIX : {
        P_MENU: 'INOUT',
        TYPE : 'SUB',
        URL : '/inout/F',
        TEXT : '장비수리',
        ICON : '/images/ic_inout_fix.svg'
    }, 
    INOUT_RENT : {
        P_MENU: 'INOUT',
        TYPE : 'SUB',
        URL : '/inout/R',
        TEXT : '장비임대',
        ICON : '/images/ic_inout_rental.svg'
    }, 
    ONLY_IN_ITEM : {
        P_MENU: 'INOUT',
        TYPE : 'SUB',
        URL : '/inout/onlyIn',
        TEXT : '반입',
        ICON : '/images/ic_only_in.svg'
    }, 
    INSPECT : {
        TYPE : 'MAIN',
        ID: 'INSPECT',
        TEXT : '자산 조사'
    }, 
    INSPECT_NORMAL : {
        P_MENU: 'INSPECT',
        TYPE : 'SUB',
        URL : '/inspect/N',
        TEXT : '정기조사',
        ICON : '/images/ic_inspect_nor.svg'
    }, 
    INSPECT_MONTH : {
        P_MENU: 'INSPECT',
        TYPE : 'SUB',
        URL : '/inspect/M',
        TEXT : '월간조사',
        ICON : '/images/ic_inspect_month.svg'
    }, 
    INSPECT_TERM : {
        P_MENU: 'INSPECT',
        TYPE : 'SUB',
        URL : '/inspect/T',
        TEXT : '수시조사',
        ICON : '/images/ic_inspect_term.svg'
    }, 
    INSPECT_ITEM : {
        P_MENU: 'INSPECT',
        TYPE : 'SUB',
        URL : '/inspect/item',
        TEXT : '자산확인',
        ICON : '/images/ic_inspect_item.svg'
    }, 
}

export const USER_TP = {
    SUPER : 'A',
    ADMIN : 'M',
    MANAGE : 'G',//일단 전체
    USER : 'U', //설치기사(자산관리/자산조사 없고 반출입작업생성불가)
    NORMAL: 'N' //대시보드하고 비밀번호변경
}

export const USER_MENU = {
    SUPER : {
        ADMIN : [
            ADMIN_MENU.DASHBOARD,
            ADMIN_MENU.ITEM,
            ADMIN_MENU.ITEM_LIST,
            ADMIN_MENU.INSPECT,
            ADMIN_MENU.ITEM_HIST,
            ADMIN_MENU.ITEM_REL,
            ADMIN_MENU.SUPPLIES,
            ADMIN_MENU.SUPPLIES_LIST,
            ADMIN_MENU.INOUT,
            ADMIN_MENU.INOUT_LIST,
            ADMIN_MENU.INOUT_HIST,
            ADMIN_MENU.STATIC,
            ADMIN_MENU.STATIC_ITEM,
            ADMIN_MENU.STATIC_SEARCH,
            ADMIN_MENU.STATIC_INOUT,
            ADMIN_MENU.STATIC_INSPECT,
            ADMIN_MENU.SETTING,
            ADMIN_MENU.CLIENT,
            ADMIN_MENU.USERS,
            // ADMIN_MENU.PASSWORD
                ],
        MOBILE: [
            MOBILE_MENU.INOUT,
            MOBILE_MENU.INOUT_SEARCH,
            MOBILE_MENU.INOUT_MOD,
            MOBILE_MENU.INOUT_FIX,
            MOBILE_MENU.INOUT_RENT,
            MOBILE_MENU.ONLY_IN_ITEM,
            MOBILE_MENU.INSPECT,
            MOBILE_MENU.INSPECT_NORMAL,
            MOBILE_MENU.INSPECT_MONTH,
            MOBILE_MENU.INSPECT_TERM,
            MOBILE_MENU.INSPECT_ITEM
                ]
    },
    ADMIN : {
        ADMIN : [
            ADMIN_MENU.DASHBOARD,
            ADMIN_MENU.ITEM,
            ADMIN_MENU.ITEM_LIST,
            ADMIN_MENU.INSPECT,
            ADMIN_MENU.ITEM_HIST,
            ADMIN_MENU.ITEM_REL,
            // ADMIN_MENU.SUPPLIES,
            // ADMIN_MENU.SUPPLIES_LIST,
            ADMIN_MENU.INOUT,
            ADMIN_MENU.INOUT_LIST,
            ADMIN_MENU.INOUT_HIST,
            ADMIN_MENU.STATIC,
            ADMIN_MENU.STATIC_ITEM,
            ADMIN_MENU.STATIC_SEARCH,
            ADMIN_MENU.STATIC_INOUT,
            ADMIN_MENU.STATIC_INSPECT,
            ADMIN_MENU.SETTING,
            ADMIN_MENU.CLIENT,
            ADMIN_MENU.USERS,
            // ADMIN_MENU.PASSWORD
                ],
        MOBILE: [
            MOBILE_MENU.INOUT,
            MOBILE_MENU.INOUT_SEARCH,
            MOBILE_MENU.INOUT_MOD,
            MOBILE_MENU.INOUT_FIX,
            MOBILE_MENU.INOUT_RENT,
            MOBILE_MENU.INSPECT,
            MOBILE_MENU.INSPECT_NORMAL,
            MOBILE_MENU.INSPECT_MONTH,
            MOBILE_MENU.INSPECT_TERM,
            MOBILE_MENU.INSPECT_ITEM
                ]
    },
    MANAGE : {
        ADMIN : [
            ADMIN_MENU.DASHBOARD,
            ADMIN_MENU.ITEM,
            ADMIN_MENU.ITEM_LIST,
            ADMIN_MENU.INSPECT,
            ADMIN_MENU.ITEM_HIST,
            ADMIN_MENU.ITEM_REL,
            ADMIN_MENU.INOUT,
            ADMIN_MENU.INOUT_LIST,
            ADMIN_MENU.INOUT_HIST,
            ADMIN_MENU.STATIC,
            ADMIN_MENU.STATIC_ITEM,
            ADMIN_MENU.STATIC_SEARCH,
            ADMIN_MENU.STATIC_INOUT,
            ADMIN_MENU.STATIC_INSPECT,
            ADMIN_MENU.SETTING,
            ADMIN_MENU.CLIENT,
            // ADMIN_MENU.USERS,
            // ADMIN_MENU.PASSWORD
                ],
        MOBILE: [
            MOBILE_MENU.INOUT,
            MOBILE_MENU.INOUT_SEARCH,
            MOBILE_MENU.INOUT_MOD,
            MOBILE_MENU.INOUT_FIX,
            MOBILE_MENU.INOUT_RENT,
            MOBILE_MENU.INSPECT,
            MOBILE_MENU.INSPECT_NORMAL,
            MOBILE_MENU.INSPECT_MONTH,
            MOBILE_MENU.INSPECT_TERM,
            MOBILE_MENU.INSPECT_ITEM
                ]
    },
    USER : {
        ADMIN : [
            ADMIN_MENU.DASHBOARD,
            ADMIN_MENU.INOUT,
            ADMIN_MENU.INOUT_LIST,
            ADMIN_MENU.INOUT_HIST,
            ADMIN_MENU.STATIC,
            ADMIN_MENU.STATIC_ITEM,
            ADMIN_MENU.STATIC_SEARCH,
            ADMIN_MENU.STATIC_INOUT,
            ADMIN_MENU.STATIC_INSPECT,
            // ADMIN_MENU.SETTING,
            // ADMIN_MENU.USERS,
            // ADMIN_MENU.PASSWORD
                ],
        MOBILE: [
            MOBILE_MENU.INOUT,
            MOBILE_MENU.INOUT_SEARCH,
            MOBILE_MENU.INOUT_MOD,
            // MOBILE_MENU.INOUT_FIX,
            // MOBILE_MENU.INOUT_RENT,
                ]
    },
    NORMAL: {
        ADMIN : [
            ADMIN_MENU.DASHBOARD,
            ADMIN_MENU.STATIC,
            ADMIN_MENU.STATIC_ITEM,
            ADMIN_MENU.STATIC_SEARCH,
            ADMIN_MENU.STATIC_INOUT,
            ADMIN_MENU.STATIC_INSPECT,
            // ADMIN_MENU.SETTING,
            // ADMIN_MENU.PASSWORD
                ],
        MOBILE: []
    },
}

export const ITEM_STATUS = {
    NORMAL : 'N',
    BAD : 'B',
    FIX : 'P',
    RENT : 'R',
    LOST : 'X',
    READY_SALE : 'S',
    SALE: 'O',
    TRASH: 'T',
    EXTINCTION: 'W',
    ETC: 'Z',
    NO_USE: 'D'
}

export const IOT_TP = {
    SEARCH: 'S',
    FIX: 'F',
    RENT: 'R',
    ETC: 'Z'
}

export const SUB_TP = {
    TRAFFIC: 'SA',
    NUMBER: 'SB',
    SPEED: 'SC',
    ETC: 'SZ'
}

export const ISP_TP = {
    NORMAL: 'N',
    MONTH: 'M',
    TERM : 'T',
}

export const DEPT_CD = {
    TP: 'T1',
    CP: 'C1',
    TS : 'S1',
    ICT : 'I1',
    MG : 'M1',
    ETC : 'Z1',
}